import axios from "axios";

const API_URL =
  "https://referral-events-service-26551171030.us-east1.run.app/api/";

const axiosInstanceExcel = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstanceExcel.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const downloadExcel = async () => {
  try {
    const response = await axiosInstanceExcel.get("/referral-events/xlsx", {
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
